<div class="flex flex-col gap-y-5 justify-between h-full">
  <div
    class="text-2xl font-bold flex items-center justify-center bg-primary-light p-3 rounded-2xl"
  >
    <h1
      [innerHTML]="resource.error.workflowOut.title"
      *ngIf="!isCustomContent() || !config.data?.title"
    ></h1>
    <h1
      *ngIf="isCustomContent()"
      [innerHTML]="config.data?.title"
      class="text-center"
    ></h1>
  </div>

  <div class="flex flex-col justify-center gap-y-5">
    @if (config.data?.contentTemplate) {
      <ng-container
        *ngTemplateOutlet="config.data?.contentTemplate || null"
      ></ng-container>
    } @else if (
      !isCustomContent() &&
      config.data?.content &&
      (config.data?.content)!.length > 0
    ) {
      <p
        class="text-center"
        [innerHTML]="resource.error.workflowOut.text1"
        *ngIf="!config.data?.content"
      ></p>

      <p
        *ngIf="config.data?.content && (config.data?.content)!.length === 1"
        class="text-center"
      >
        {{ (config.data?.content)![0] }}
      </p>

      <p class="text-2xl font-bold text-center" *ngIf="!loadPhone()">
        {{ isPartner && store.context().canalVente != CANAL_VENTE_C ? VyvPhone : store.contactPhone() }}
      </p>
      <p-skeleton
        width="12rem"
        height="4rem"
        styleClass=" mx-auto mb-2"
        *ngIf="loadPhone()"
      />

      <p class="text-center">
        {{ resource.error.workflowOut.text2 }}
        <br />
        {{ resource.error.workflowOut.text3 }}
      </p>
    } @else {
      @for (line of config.data?.content!; track $index) {
        <p class="text-center" [innerHTML]="line"></p>
      }
    }
  </div>

  <div class="flex items-center justify-center">
    @if (!isCustomContent()) {
      <button
        pButton
        type="button"
        class="button-NS w-fit-content font-bold mx-auto"
        title="{{ resource.error.workflowOut.action }}"
        (click)="closePopup()"
      >
        {{ resource.error.workflowOut.action }}
      </button>
    } @else {
      @for (action of config.data?.actions!; track $index) {
        <button
          pButton
          type="button"
          class="button-NS w-fit-content font-bold mx-auto"
          title="{{ action.text }}"
          (click)="validation()"
        >
          {{ action.text }}
        </button>
      }
    }
  </div>
</div>
